import {useEffect} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";

export default function MapDarkOverlay() {
    const map = useMap();
    const mapsLib = useMapsLibrary("maps");

    useEffect(() => {
        if (!map || !mapsLib) return;

        class DarkOverlay extends mapsLib.OverlayView {
            overlayElement = null;

            onAdd() {
                const element = document.createElement("div");

                Object.assign(element.style, {
                    position: "absolute",
                    pointerEvents: "none",
                });

                this.overlayElement = element;
                this.getPanes()?.overlayLayer.appendChild(element);
            }

            draw() {
                if (!this.overlayElement) return;

                const projection = this.getProjection();
                const bounds = map.getBounds();

                if (!projection || !bounds) return;

                const northEast = projection.fromLatLngToDivPixel(bounds.getNorthEast());
                const southWest = projection.fromLatLngToDivPixel(bounds.getSouthWest());

                if (!northEast || !southWest) return;

                const extraSpace = 400;
                const width = northEast.x - southWest.x;
                const height = southWest.y - northEast.y;
                const centerX = extraSpace + width / 2;
                const centerY = extraSpace + height / 2;
                const gradientRadius = Math.max(width, height) * 0.65;
                const element = this.overlayElement;

                element.style.left = `${southWest.x - extraSpace}px`;
                element.style.top = `${northEast.y - extraSpace}px`;
                element.style.width = `${width + extraSpace * 2}px`;
                element.style.height = `${height + extraSpace * 2}px`;
                element.style.background = `
                    radial-gradient(
                        circle ${gradientRadius}px at ${centerX}px ${centerY}px,
                        rgba(0, 0, 0, 0.25) 0%,
                        rgba(0, 0, 0, 0.45) 35%,
                        rgba(0, 0, 0, 0.60) 70%,
                        rgba(0, 0, 0, 0.85) 100%
                    )
                `;
            }

            onRemove() {
                this.overlayElement?.remove();
                this.overlayElement = null;
            }
        }

        const overlay = new DarkOverlay();

        overlay.setMap(map);

        return () => overlay.setMap(null);
    }, [map, mapsLib]);

    return null;
}
